import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function AhwatukeeFoothillsPage() {
  return <LocationPageTemplate city="Ahwatukee Foothills" cityShort="Ahwatukee" slug="ahwatukee-foothills" data-id="element-1011" />;
}